import { TabMenuItem } from 'components/ui';

export const dependentMenu: TabMenuItem[] = [
  {
    name: 'Details',
    to: 'details',
  },
  {
    name: 'Timeline',
    to: 'timeline',
  }
];
